import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';
import Tab1 from './Tab1';
import { Print, Save, SwipeUp, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Box, Typography, styled } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../../../InputT';
import Tab2 from './Tab2';
import Amortissement from '../../../../../Functions/Traitement/Amortissement';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import Pret from '../../../../../Models/Pret';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import Tab3 from './Tab3';
import Tab4 from './Tab4';
import Tab5 from './Tab5';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';
import Datas from "../../../../../Data/Data.json"
import Garantie from '../../../../../Models/Garantie';
import RELATION from '../../../../../Models/Relation';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import { DemandeQardDto } from '../../../../../Models/DemandeQardDto';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import ParamsQard from '../../../../../Models/ParamsQard';
import ReformatNumber from '../../../../../Functions/Traitement/ReformatNumber';
//import "../../Assets/Styles/StyleForm.css";



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const Proposition = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  // const [StartSearchG, SeStartSearchG] = useState(false);
  // const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [sbmit, setSbmit] = useState("")
  const [data, setData] = useState<DemandeQardDto[]>([])
  const navigate = useNavigate()
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [radioaCheck, setRadioaCheck] = useState(false);
  const [garantiesTableau, setGarantiesTableau] = useState<DataTypeTable[]>([]);
  const [datatabamort, setdatatabamort] = useState([]);
  

  
  const loadFinancement=()=>
  {
    localStorage.clear()
    setPageLoad(false)
    setLoading(true)
    setData([])

    let searchClientComptes: ParamsPicklist = { CodeAgence: user.codage, Table: "DEMAND_FINQARD", Colonne1: "EtapeActuelle", Colonne2: "", Init: "PROPOSITION", Colagence: 'CODAGE', Choix: 34 }

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(searchClientComptes))
      }
    };
    axios(config)
      .then((response) => {
        //alert('ok')
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          if (res.StatutCode == 200) 
          {
            let datas = res.Result.Table;
             //alert(JSON.stringify(datas))

            //alert(datas.length)
            if (datas.length === 0) {
              SweetAlert.fire({ title: "Aucune demande de prêt en cour", icon: "warning" })
            }
            else {
            //  var datat: any[] = []; 
             var newData: DemandeQardDto[] = [];
              // datas.map((data: any) => {
              //   //alert(data.NUMDOS+" : "+data.UTILISAI+' - '+data.AGCCPT)
              //   // if (data.UTILISAI != user.coduti && data.AGCCPT == user.codage) {
              //     datat.push({
              //       ...data,
              //       Numcli:data.NUMCLI,
              //       generateNewAccount: false,
              //     });
              //   // }
              //   })
              datas.map((data: any, indice: number) => {
               newData.push({
                   ...data,
                  key: indice,
                  NumeroDemande: data.NumeroDemande,
                  Numcli: data.NUMCLI,
                  NOMCLI: data.NOMCLI,
                  DateDemande : data.DateDemande ? (new Date(data.DateDemande.substring(0, 10))).toLocaleDateString("fr") : '',
                  CodeFinancement:data.CodeFinancement,
                  MontantDemande:formatNumber(data.MontantDemande) 
               })});

              setData(newData);
           }
          }
        } else {
          alert(JSON.stringify(response))
        }

        setLoading(false)
      }).catch((error) => {
        setLoading(false)
        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
      })

  }


  if (pageLoad) 
  {
    loadFinancement();
  }


 

  const columns: ColumnsType<any> = [
    {
      title: 'Date Demande',
      dataIndex: 'DateDemande',
    },
    {
      title: 'N° Demande',
      dataIndex: 'NumeroDemande',
    },
    {
      title: 'N° Client',
      dataIndex: 'Numcli',
    },
    {
      title: 'Nom Client',
      dataIndex: 'NOMCLI',
    },
     {
      title: 'Montant Demandé',
      dataIndex: 'MontantDemande',
    },
    {
      title: 'Utilisateur Demande',
      dataIndex: 'UtilDemande',
    },
    // {
    //   title: 'Type financement',
    //   dataIndex: 'TypeFinancementID',
    // },
    // {
    //   title: 'Code Gestionnaire',
    //   dataIndex: 'CODGEA',
    // },
    {
      title: 'Motif Demande',
      dataIndex: 'MOTIFDEM',
    }
  ];

  //  : number,
  //  : number,
  // montantTA : number,
  // echeancierPlusTA : number,
  //  : number,
  // echeancierTot : number,
  //  : Date

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
     setSelectedRowKeys([])
  }


  function handleAnulle() {
    setRadioaCheck(false)
    setImpActive(true)
     setdatatabamort([]);
    setGarantiesTableau([]);
    //setData([])
    form.resetFields()
   
    initialiazeButton()
    setSelectedRowKeys([])

    // localStorage.setItem(Data.LocalVariable.reset, "1")
    // localStorage.setItem(Data.LocalVariable.Mainreset, "1")
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }

  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)
  }

  function modifButton() {
    setRadioaCheck(true)
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab1'>
          <UserOutlined />
          Détaille demande
        </span>
      ),
      children: <Tab1 form={form} />, //form={form}
    },
    {
      key: '2',
      label: (
        <span id='Tab2'>
          <UserOutlined />
          Garanties
        </span>
      ),
      children: <Tab2 form={form} garantiesTableau={garantiesTableau} />, //form={form}
    },

     {
      key: '3',
      label: (
        <span id='Tab3'>
          <UserOutlined />
          Documents
        </span>
      ),
      children: <Tab3 form={form} />, //form={form}
    },
    {
      key: '4',
      label: (
        <span id='Tab4'>
          <UserOutlined />
          Frais de Gestion
        </span>
      ),
      children: <Tab4 form={form} />, //form={form}
    },
    {
      key: '5',
      label: (
        <span id='Tab5'>
          <UserOutlined />
          Tableau d'amortissement
        </span>
      ),
      children: <Tab5 form={form}  data={datatabamort}/>, //form={form}
    }
  ];



  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };



  const onFinish = (values: any) => 
  {
   
     var DemandeQard: DemandeQardDto = {
            CODAGE: user.codage,
            DatePremEch: formatDate(values.DatePremEch),
            // DateDemande: user.datjour,
            Numcli:values.NUMCLI,
            NOMCLI: values.lib_NUMCLI,
            ...values
          };

          DemandeQard.Documents = values.Document || [];
    

    SweetAlert.fire({
             title:
               'Voulez-vous enregistrer la proposition de financment Qard de type ' +
               values.lib_CodeQard +
               '\n du client : ' +
               values.lib_NUMCLI +
               '\n à hauteur du montant : ' +
               formatNumber(values.MontantPropose) +
               ' XAF ?',
             showCancelButton: true,
             color: 'green',
             confirmButtonText: 'Yes',
             confirmButtonColor: 'green',
             cancelButtonColor: 'darkred',
             cancelButtonText: 'No',
             showLoaderOnConfirm: true,
             icon: 'question',
    }).then((res) =>{
      if (res.isConfirmed) 
      {
   
             
            try {
                      setLoading(true);
                      setIsSubmit(true);
                        DemandeQard.UtilPropose=user.coduti;
                        DemandeQard.CodeUti=user.coduti;
                        DemandeQard.DatePropose= user.datjour;
                      let data = Crypter.encrypt(JSON.stringify(DemandeQard));
        
                      let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.ProposeQard,
                        headers: {
                          Authorization: authHeader(),
                          'Content-Type': 'application/json',
                        },
                        data: data,
                      };
            
                  axios
                    .request(config)
                    .then((response) => {
                      setLoading(false);
                      if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
    
                      if (res.StatutCode == 200) {
                        initialiazeButton();
                        form.resetFields();
                        // ✅ Vider le tableau après enregistrement réussi
                        setGarantiesTableau([]);
                        setdatatabamort([]);
                        setImpActive(false);
                        loadFinancement();
                        SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'success' });
                      } else {
                        SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
                      }
              }             
          })                          
           .catch((error) => 
            {
                  setLoading(false);
                  console.log(error);
                  SweetAlert.fire({ title: error, icon: 'error' });
             });
       
      } catch (error)
       {
            SweetAlert.fire({
              title: 'Error ocured while getting warranties or avalistes',
              icon: 'error',
            }); 
        }
      }
      }
    );
          
        
}

     
  function modif() {
    modifButton()

  }


  const onSelectChange = (newSelectedRowKeys: any) => {

    console.log('selectedRowKeys changed: ', data[newSelectedRowKeys]);
    form.setFieldsValue(data[newSelectedRowKeys])
    handleDemandePret()
    setSelectedRowKeys(newSelectedRowKeys);
    
  }; const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };


  function handleDemandePret() {

    localStorage.setItem(Data.LocalVariable.reset, "1")
    //let searchPret:Params={CodeAgence:'',Table: "CPRETS",Colonne1:"",Colonne2:"",Colagence:'101', Init: form.getFieldValue("NUMDOS"), Choix:3}
    let data = Crypter.encrypt(form.getFieldValue("NumeroDemande"));
    let numdos = form.getFieldValue("NumeroDemande")
    let dataction = Crypter.encrypt('READ_DEMANDE');

    if (data.length != 0) {
      // form.setFieldValue('garantie', '')
      // form.setFieldValue('avaliste', '')
      initialiazeButton()
      setLoading(true)
      form.resetFields()
      form.setFieldValue('NumeroDemande', numdos)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ReadFiancementQard,
        headers: {
          'CypherNumeroDemandeQard': data,
          'CypherAction': dataction,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            console.log(res)
            if (res.StatutCode == 200) 
            {
                 form.setFieldsValue(res.Result.Table1[0]);
                 form.setFieldValue('DatePremEch', ReformatDate(res.Result.Table1[0].DatePremEch));
                 form.setFieldValue('DateDemande', ReformatDate(res.Result.Table1[0].DateDemande));
                 
                 form.setFieldValue('lib_NUMCLI',res.Result.Table1[0].NOMCLI);
                 form.setFieldValue('MontantPropose',res.Result.Table1[0].MontantDemande);
                 
                  //form.setFieldValue('', )
            const garantiesRetournees: DataTypeTable[] = [];
            var newData:any =  [];

            
            if(res.Result.Table2)
            {
               // garantiesRetournees= res.Result.Table2.map((data:any,index:number)=>
              //   ({...data, valCouvert:data.montantcouvert}));
               let montantGarantieCouvert=0;
                
              res.Result.Table2.map((data:any,index:number)=>{
                montantGarantieCouvert+=data.MontantCouvert;
                garantiesRetournees.push({ ...data, 
                  valCouvert:data.MontantCouvert
                })
              })
               form.setFieldValue('montantGarantieCouvert',montantGarantieCouvert);
            }

              if(res.Result.Table3)
            {
               // garantiesRetournees= res.Result.Table2.map((data:any,index:number)=>
              //   ({...data, valCouvert:data.montantcouvert}));
               res.Result.Table3.map((data:any,index:number)=>{newData.push({ ...data,
                 CapitalInitial:formatNumber(data.CapitalInitial),
                 CapitalRembourse:formatNumber(data.CapitalRembourse),
                 CapitalRestant:formatNumber(data.CapitalRestant),
                 DateEcheance:    data.DateEcheance ? (new Date(data.DateEcheance.substring(0, 10))).toLocaleDateString("fr") : '',
               })});

               setdatatabamort(newData);
            }
              // alert(JSON.stringify(res.Result.Table4))

              setGarantiesTableau(garantiesRetournees);
              setdatatabamort(newData as any)
              consultTypecard();
              initialiazeButton();
              cunsultButton();  
              setEnregActve(false);

            }
            else {
              localStorage.removeItem(Data.LocalVariable.reset)
              SweetAlert.fire({ title: res.Message, icon: "warning" })
              setSelectedRowKeys([])
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          localStorage.removeItem(Data.LocalVariable.reset)
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: error, icon: "error" })
          setSelectedRowKeys([])
        });
    }
  }


function consultTypecard() {
    if (form.getFieldValue('CodeQard') == null) {
      SweetAlert.fire({ title: 'Svp renseigner le Code du type de Qard ', icon: 'warning' });
    } else {
      let data = form.getFieldValue('CodeQard');
      if (data.length != 0) {
        setLoading(true);
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ReadParamsQard,
          headers: {
            CypherCodeQard:  Crypter.encrypt(data),
            Authorization: authHeader(),
            'Content-Type': 'application/json',
          },
        };

        axios
          .request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;

              if (res.StatutCode == 200) {
                let paramsQardData: ParamsQard = res.Result.Table1[0];
                const frais = res.Result.Table2.reduce(
                  (total: number, x: any) => total + Number(x.MONFIX || 0),
                  0
                );

                paramsQardData.Frais = res.Result.Table2.map((x: any) => x.CODOPE);

                form.setFieldValue('CodeFrais', paramsQardData.Frais);
      
              } else {
                SweetAlert.fire({ title: 'Warning', text: res.Message, icon: 'warning' });
              }
            }
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
            SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
          });
      }
    }
  }

  setTimeout(() => {
    try {
      let reset = localStorage.getItem(Data.LocalVariable.Mainreset)
      if (reset == "1") {
        setSelectedRowKeys([])
        localStorage.removeItem(Data.LocalVariable.Mainreset)
      }
    }
    catch (error) { }
  }, .1)

  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>PROPOSITION DE FINANCEMENT</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form disabled={!ajoutActve} preserve  autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                {/*
                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Saisir
                </Button>
                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" onClick={affiche} block>
                  Afficher
                </Button>
                <Button size='large' className='bt_add' onClick={printTab} disabled={impActive} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button> */}
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' onSubmit={onFinish} disabled={enregActve} type="ghost" htmlType="submit" block>
                  Proposer
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div>
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
             <Box display={"flex"} fontStyle="inherit" className='border-left tabElementAuto'>
                <Spin spinning={loading}>
                  <Form disabled={radioaCheck}>
                    <Table size='small' style={{ width: 'auto' }} rowSelection={{ ...rowSelection, type: "radio", }} columns={columns} dataSource={data} scroll={{ y: 200, x: 10 }} pagination={false} />
                  </Form>
                </Spin>
               </Box> 
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default Proposition;